import React from 'react';
import VideoTwo from '../video/VideoTwo';
import { FiCheck } from "react-icons/fi";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


const PopupData = [
    {
        id: "01",
        image: "./images/bg/bg-image-4.jpg",
        popupLink: [
            'https://www.youtube.com/watch?v=lYPuDNzef4Q',
        ],
    }
]

const AboutFour = ({image}) => {
    return (
        <div className="about-area about-style-4 rn-section-gap">
            <div className="container">
                <div className="row row--40 align-items-center">
                    <div className="col-lg-6">
                        {PopupData.map((item) => (
                            <div className="video-btn" key={item.id}>
                                <VideoTwo imagename={`${image}`} galleryItem={item} />
                            </div>
                        ))}
                    </div>
                    <div className="col-lg-6 mt_md--40 mt_sm--40">
                        <div className="content">
                            <div className="inner">
                                <h3 className="title">About Passionate World University(PWU)
                                </h3>
                                {/* <h3 className="title">PWU Specializes in <br /> Small <strong>Corporate Business.</strong></h3> */}
                                {/* <ul className="feature-list">
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <h4 className="title">Empowering Life, Business & Income</h4>
                                            <p className="text">Lorem ipsum dolor consectetur adipiscing do eiusmod tempor incididunt labore.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <FiCheck />
                                        </div>
                                        <div className="title-wrapper">
                                            <h4 className="title">A good Business man has a fixed plan</h4>
                                            <p className="text">Lorem ipsum dolor consectetur adipiscing do eiusmod tempor incididunt labore.</p>
                                        </div>
                                    </li>
                                </ul> */}
                                <div>
                                    <p>Passionate World University (PWU) is a purpose-driven education and consulting platform built to unlock human potential and create income opportunities through world-class training, coaching, and community support. Founded by Jahid Hasan, PWU is designed for aspiring entrepreneurs, business owners, CEOs, executives, professionals, and students—anyone committed to transforming their life, business, and income.
                                    </p>
                                </div>
                                <div className="about-btn mt--30">
                                    <Link className="btn-default" to="/about-us">About Our PWU</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutFour
